import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import AnnouncementBar from "@/components/AnnouncementBar";
import { SiteSettingsProvider } from "@/context/SiteSettings";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Music from "@/pages/Music";
import Videos from "@/pages/Videos";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        if (window.__lenis) {
            window.__lenis.scrollTo(0, { immediate: true });
        } else {
            window.scrollTo(0, 0);
        }
    }, [pathname]);
    return null;
};

const useLenis = () => {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        window.__lenis = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);
};

function App() {
    useLenis();
    return (
        <div className="App min-h-screen bg-[#0A0A0E]">
            <BrowserRouter>
              <SiteSettingsProvider>
                <ScrollToTop />
                <AnnouncementBar />
                <Navbar />
                <main style={{ paddingTop: "var(--bar-h, 0px)" }}>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/music" element={<Music />} />
                        <Route path="/videos" element={<Videos />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/admin" element={<Admin />} />
                    </Routes>
                </main>
                <Footer />
                <Toaster
                    theme="dark"
                    position="top-center"
                    toastOptions={{
                        style: {
                            background: "#121218",
                            border: "1px solid rgba(200,151,43,0.35)",
                            color: "#F8FAFC",
                        },
                    }}
                />
              </SiteSettingsProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
